import React from 'react';

import adminMenuItems from './adminMenuItems';
import customerMenuItems from './customerMenuItems';

export default { adminMenuItems, customerMenuItems };
